import React from "react";
import ReactDOM from "react-dom/client";
import { useEffect, useState } from "react";


const Dimension = () => {
    const images = window.Dimension_IMAGES || [];

    return (

        <>
            <div class='flex items-center justify-center h-full w-[85%] object-contain'>
                <img
                    src={images[1]}
                    alt="Child with backpack"
                    class="rounded-lg" />
            </div><div class='flex items-center justify-center h-full w-[85%] object-contain'>
                <img
                    src={images[2]}
                    alt="Child with backpack"
                    class="rounded-lg" />
            </div><div class='flex items-center justify-center h-full w-[85%] object-contain'>
                <img
                    src={images[3]}

                    alt="Child with backpack"
                    class="rounded-lg" />
            </div>
        </>

    )
};

// ✅ Render React Component in Liquid File
const rootEl = document.getElementById("react-dimension");
if (rootEl) {
    ReactDOM.createRoot(rootEl).render(<Dimension />);
}
